const Azure = () => {
  return <h3>Azure</h3>;
};

export default Azure;
